import React from 'react';

import _get from 'lodash/get';

import PropTypes from 'prop-types';

class DMAv extends React.Component {
	static contextTypes = {
		FormCtrl: PropTypes.object.isRequired,
	};

	getValue(field) {
		return _get(this.context.FormCtrl.inputs, field).getValue();
	}

	render() {
		return null;
	}
}

export default DMAv;
